import React from 'react';
import { MessageCircle } from '../Icons';
import './WhatsAppButton.css';

export const WhatsAppButton = () => {
  const phoneNumber = '541169766847';
  const message = 'Hola Agustin! Vi tu portfolio y me gustaria contactarte.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a 
      href={whatsappUrl} 
      className="whatsapp-float" 
      target="_blank" 
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle size={28} />
      <span className="whatsapp-tooltip">¡Hablemos!</span>
    </a>
  );
};
